import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

type Props = {
  onClose: () => void,
  onAgree: () => void,
  onDisagree: () => void,
  title: string,
  text?: string,
  open: boolean,
}

export default function Modal({ onClose, onAgree, onDisagree, title, text, open }: Props) {
  return (
    <Dialog
      open={open}
      keepMounted
      onClose={onClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {!!text && (
          <DialogContentText id="alert-dialog-slide-description">
            {text}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onDisagree} color="primary">
          Отмена
        </Button>
        <Button onClick={onAgree} color="primary">
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
}
